export default {
  siteMetadata: {
    title: 'Retrobie',
    description:
      "We stock high-quality sneakers, running shoes, trainers, gym shoes, sports shoes and classy men's shoes at affordable prices in Kenya. We also do personal thrifting and accept shoe requests from trusted repeat customers. Delivery within the CBD is free.",
    author: 'Kofi Bradley',
  },
};
